/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { useDataTableContext } from "../../store/DataTableProvider";
import { QuickActionRunRowWorkflowTable } from "../../layout/DataTableQuickActionBar/QuickActionRunRow";
import { GridApi } from "ag-grid-community";
import { DataTableRowData } from "../../layout/DataTable";
import { isWorkflowTable } from "../../store/DataTableProvider.helpers";
import { RunProgress } from "./RunProgress";
import { QuickActionCopyRow } from "pages/gdt/layout/DataTableQuickActionBar/QuickActionCopyRow";
import { cellRendererQuickActionStyles } from "../CellRendererQuickActionsAnalysisTable";

interface CellRendererQuickActionsWorkflowTableProps {
  rowId: string;
  gridApi: GridApi<DataTableRowData> | undefined;
  tableId: string;
  readOnly?: boolean;
}

export const CellRendererQuickActionsWorkflowTable = memo(
  function CellRendererQuickActionsWorkflowTable({
    rowId,
    gridApi,
    tableId,
    readOnly,
  }: CellRendererQuickActionsWorkflowTableProps) {
    const row = useDataTableContext((s) => {
      const table = s.tables
        .filter(isWorkflowTable)
        .find((table) => table.id === tableId);
      return table?.rows.find((row) => row.id === rowId);
    });
    const columns = useDataTableContext((s) => {
      const table = s.tables.find((table) => table.id === tableId);
      return table?.columns;
    });

    if (columns === undefined || row === undefined) {
      return null;
    }

    const run = row.run;

    return (
      <span css={cellRendererQuickActionStyles.root}>
        {run == null ? (
          <QuickActionRunRowWorkflowTable
            readOnly={readOnly}
            tableId={tableId}
            rowId={row.id}
            gridApi={gridApi}
          />
        ) : (
          <RunProgress row={{ ...row, run }} />
        )}
        <QuickActionCopyRow tableId={tableId} rowId={row.id} />
      </span>
    );
  },
);
